import { TAppState } from '../../types/appState';

export const isEarlyAccessSelector = (state: TAppState) => state.isEarlyAccess;
